module.exports = __webpack_public_path__ + "img/qichepiao.61db40b2.png";